import { Link as RouterLink, useLocation } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { ArrowRightIcon } from "@mui/x-date-pickers";
import { ThemeProvider } from "styled-components";
import { newLightStyles } from "src/user.InterfaceLayer/styles/theme.style";
import Colors from "src/general/constants/colors";
import { URLHOST } from "src/old/Const/envConst";
import { useBreadcrumbs } from "./BreadcrumbsContext";

const BreadcrumbsMenu = () => {
	const location = useLocation();
	const { breadcrumbs: customBreadcrumbs } = useBreadcrumbs();

	const defaultPathnames = location.pathname.split("/").filter((x) => x);

	const pathRename = (pathname: string) => {
		if (pathname === "contacts") return "Контакты";
		if (pathname === "organization-info") return "Сведения об организации";
		if (pathname === "association") return "Ассоциация PreventAge";
		return pathname;
	};

	// Если есть кастомные крошки, используем их, иначе - дефолтные
	const items =
		customBreadcrumbs.length > 0
			? customBreadcrumbs
			: [
					{ path: URLHOST, name: "Главная страница" },
					...defaultPathnames.map((path) => ({
						path: `/${defaultPathnames
							.slice(0, defaultPathnames.indexOf(path) + 1)
							.join("/")}`,
						name: pathRename(path),
					})),
			  ];

	return (
		<ThemeProvider theme={newLightStyles}>
			<Breadcrumbs
				separator={<ArrowRightIcon style={{ color: Colors.BLUE_015 }} />}
				aria-label="breadcrumb"
			>
				{items.map((item, index) => {
					const isLast = index === items.length - 1;

					return isLast ? (
						<Typography
							key={item.path}
							variant="body3"
							style={{ color: Colors.BLACK_OLD, cursor: "pointer" }}
						>
							{item.name}
						</Typography>
					) : (
						<Link
							key={item.path}
							underline="hover"
							component={RouterLink}
							to={item.path}
						>
							<Typography
								variant="body3"
								style={{ color: Colors.GREY, cursor: "pointer" }}
							>
								{item.name}
							</Typography>
						</Link>
					);
				})}
			</Breadcrumbs>
		</ThemeProvider>
	);
};

export default BreadcrumbsMenu;
